var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.287 212.287",
    style: {
      enableBackground: "new 0 0 212.287 212.287"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M212.043,81.891c-0.588-1.81-2.153-3.129-4.037-3.403l-67.287-9.777L110.628,7.737c-0.842-1.707-2.581-2.787-4.484-2.787  c-1.903,0-3.642,1.081-4.484,2.787L71.568,68.711L4.281,78.487c-1.884,0.274-3.448,1.593-4.037,3.403  c-0.588,1.81-0.098,3.797,1.265,5.126l48.689,47.46l-11.494,67.015c-0.322,1.876,0.45,3.771,1.989,4.89  c1.54,1.12,3.582,1.265,5.266,0.381l60.184-31.64l60.184,31.64c0.731,0.384,1.53,0.574,2.326,0.574c1.037,0,2.068-0.322,2.939-0.955  c1.54-1.119,2.311-3.014,1.989-4.89l-11.494-67.015l48.689-47.46C212.14,85.688,212.63,83.701,212.043,81.891z",
    fill: "#b9b9b9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart);
export default __webpack_public_path__ + "static/media/start.5b0cde2f623c378a82326e0fb76523b4.svg";
export { ForwardRef as ReactComponent };